import { defineComponent } from "vue";

// services
import processSevices from "@/services/legal/service.js";

// Components
import MainBarMenuV2 from "@/components/layouts/MainBarMenuV2.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";
import Typography from "@/components/general/Typography";
import BarChart from "@/components/charts/BarChart.js";
import useInputs from "@/components/general/Inputs";
import Button from "@/components/general/Button";
const { Select, Input } = useInputs();

export default defineComponent({
  components: {
    MainBarMenuV2,
    HeadingUser,
    Typography,
    BarChart,
    Select,
    Input,
    Button,
  },
  data() {
    return {
      isBusy: true,
      results: {
        labels: [],
        dfv: [],
        enc: [],
        fvb: [],
      },
      valueFilters: {
        city_id: null,
        status: null,
        plaintiff_name: null,
        defendants: null,
        court_id: null,
        laborUnion: null,
        lawyer_id: null,
        area_id: null,
        object_id: null,
        // result: null,
      },
      options: {
        cities: [],
        result: [],
        defendants: [],
        status: [],
        courts: [],
        lawyers: [],
        unions: [],
        areas: [],
        objects: [],
      },
      areas: [],
      cities: [],
      status: [],
      courts: [],
      unions: [],
      chartData: { barchart: {
        labels: [],
        datasets: [],
      } },
      chartOptions: {
        barchart: {
          responsive: true,
          maintainAspectRatio: false,
        },
      },
    };
  },
  methods: {
    redirect() {
      alert("Redirigiendo");
    },
    initData() {
      const me = this;
      me.isBusy = true;
      processSevices.getIndicators({}).then((resp) => {
        me.fillData(resp);
      }).finally(() => {
        me.isBusy = false;
      });
      processSevices.getOptions().then((resp) => {
        this.options = resp.data;
      });
    },
    clearFilter() {
      const me = this;
      me.isBusy = true;
      me.valueFilters = {
        city_id: null,
        status: null,
        plaintiff_name: null,
        defendants: null,
        court_id: null,
        laborUnion: null,
        lawyer_id: null,
        area_id: null,
        object_id: null,
      };
      processSevices.getIndicators({}).then((resp) => {
        me.fillData(resp);
      }).finally(() => {
        me.isBusy = false;
      });
    },
    async getIndicators() {
      const me = this;
      const data = {
        city_id: me.valueFilters.city_id?.id,
        defendants: me.valueFilters.defendants?.id,
        status: me.valueFilters.status?.id,
        plaintiff_name: me.valueFilters.plaintiff_name,
        court_id: me.valueFilters.court_id?.id,
        'unions[0]': me.valueFilters.laborUnion?.id,
        lawyer_id: me.valueFilters.lawyer_id?.id,
        area_id: me.valueFilters.area_id?.id,
        object_id: me.valueFilters.object_id?.id,
      };
      me.isBusy = true;
      try {
        const resp = await processSevices.getIndicators(data);
        me.fillData(resp);
      } catch (error) {
        console.log(error);
      } finally {
        me.isBusy = false;
      }
    },
    fillData(resp) {
      const me = this;
      me.results = resp.results;
      me.areas = resp.areas;
      me.cities = resp.cities;
      me.courts = resp.courts;
      me.status = resp.status;
      me.unions = resp.unions;
      me.cities.sort((a, b) => {
        if (a.value < b.value) {
          return 1;
        }
        if (a.value > b.value) {
          return -1;
        }
        return 0;
      });
      me.chartData.barchart.labels = Object.keys(resp.results.labels).map((v) =>  parseInt(v) + 1 < 10 ? "0" + (parseInt(v) + 1) : parseInt(v) + 1)
      me.chartData.barchart.datasets = [
        {
          label: "A favor",
          data: resp.results.fvb,
          backgroundColor: "#2EBFCA",
          stack: "Stack 0",
        },
        {
          label: "En Contra",
          data: resp.results.dfv,
          backgroundColor: "#DA1414",
          stack: "Stack 0",
        },
        {
          label: "En Curso",
          data: resp.results.enc,
          backgroundColor: "#FFB200",
          stack: "Stack 0",
        },
      ]
    }
  },
  computed: {
    isDisabled() {
      return Object.values(this.valueFilters).some(
        (filter) => filter !== null && filter !== ""
      );
    },
  },
  mounted() {
    this.initData();
  },
});
